import React from 'react';
import PropTypes from "prop-types";

import RetailerProduct from '../ProductModal';
import RecommendationGrid from '../RecommendationGrid';
import Api from '../../Api';
import Processing from '../../components/Processing';
import LightBox from '../../components/LightBox';
import CategoryBar from '../../components/CategoryBar';

import BrandHeader from './header';
import CollectionStrip from './collection_strip';
import {CATEGORY_FILTERS} from '../../consts';

import './style.less';
import BreadCrumb from "../../components/BreadCrumb/index";

const calculateButtonText = selections => {
  let totalCases = 0;
  selections.forEach(selection => {
    totalCases += selection.batches;
  });

  if (totalCases >= 2) return 'Add Cases to Bag';

  return 'Add Case to Bag';
};

export default class Brand extends React.Component {
  constructor(props) {
    super(props);

    this.searchChanged = this.searchChanged.bind(this);

    Api.Utils.bindThis(this, [
      'refresh',
      'selectProduct',
      'productModal',
      'closeProductModal',
      'redirectToBrandPage',
      'addToCart',
      'getCartSelection',
      'getRecommendedProduct',
      'categoriesUpdated',
      'onBreadCrumb',
      'onCategory',
    ]);

    this.state = {
      categories: null,
      recommendations: null,
      filteredRecommendations: null,
      brandInfo: null,
      closestBrandRetailer: null,
      productToken: props.params.productId
    };
  }

  categoriesUpdated() {
    this.setState({
      categories: Api.cache.getCategories()
    });
  }

  componentWillMount() {
    this.refresh();

    Api.getRetailer(this.props.params.retailerId, true);
    Api.cache.addChangeListener(this.categoriesUpdated, Api.cache.eventTypes.CATEGORIES_CHANGED);

    Api.cache.setProductSearchActive(false);
    Api.cache.setProductSearchTerm('');
    Api.cache.addChangeListener(this.searchChanged, Api.cache.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    Api.cache.removeChangeListener(this.searchChanged, Api.cache.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
    Api.cache.removeChangeListener(this.categoriesUpdated, Api.cache.eventTypes.CATEGORIES_CHANGED);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.brandToken !== nextProps.params.brandToken) {
      this.setState({ recommendations: null });
      Api.getBrand(nextProps.params.brandToken, true)
        .then(brandInfo => {
            this.setState({brandInfo});
        })
        .then(this.refresh);
    }

    if (this.state.productToken !== nextProps.params.productId) {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

      this.setState({
        productToken: nextProps.params.productId
      });
    }
  }

  componentDidUpdate() {
    if (this.scrollTop) {
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop;
    }
  }

  selectProduct(product) {
    let url = `/retailer/${this.props.params.retailerId}/brand/${this.props.params.brandToken}/product/${product.token}`;
    this.context.router.push(url);
  }

  refresh() {
    Api.getBrand(this.props.params.brandToken, true)
      .then(
        (brandInfo) => {
          this.setState({brandInfo});
        }
      );

    Api.getClosestBrandRetailer(this.props.params.brandToken)
      .then(
        (closestBrandRetailer) => {
          this.setState({closestBrandRetailer});
        }
      );

    Api
      .getProductCollections(true)
      .then(
        () => {
          return Api.getBrandProducts(this.props.params.brandToken);
        }
      )
      .then(
        (recommendations) => {
          this.setState({recommendations});
        }
      );

    Api.getRetailer(this.props.params.retailerId, true)
      .then(
        (retailer) => {
          this.setState({retailer});
        },
        (error) => {
          if (error.httpStatusCode === 401) {
            let user = Api.cache.getUser();
            if (user && user.retailer_token && user.retailer_token !== this.props.params.retailerId) {
              // Send the user to the Retailer they actually own.
              this.context.router.push(`/retailer/${user.retailer_token}`);
            } else {
              this.context.router.push('/');
            }
          } else {
            console.log(error);
          }
        }
      );
    Api.getCategories(true)
      .then(
        (categories) => {
          this.setState({categories})
        }, (error) => {
          console.log(error);
        }
      );
  }

  closeProductModal() {
    this.redirectToBrandPage();
  }

  getRecommendedProduct(productToken) {
    let recommendedProduct = null;

    if (this.state.recommendations && this.state.recommendations.products) {
      recommendedProduct = this.state.recommendations.products[productToken];
    }

    if (recommendedProduct) {
      return Promise.resolve(recommendedProduct);
    }

    return Api.getProduct(productToken, true)
      .then(productResponse => productResponse.products[productToken]);
  }

  productModal() {
    if (this.state.productToken) {
      document.body.classList.add('noscroll');
    } else {
      document.body.classList.remove('noscroll');
    }

    if (!this.state.productToken) return;

    let cartSelection = this.getCartSelection();

    return (
      <LightBox onClose={this.closeProductModal}>
        <RetailerProduct
          productToken={this.state.productToken}
          retailerToken={this.props.params.retailerId}
          onSave={this.addToCart}
          defaultSelection={cartSelection}
          buttonText={!cartSelection ? calculateButtonText : 'Save'}
        />
      </LightBox>
    );
  }

  redirectToBrandPage() {
    this.context.router.push(`/retailer/${this.props.params.retailerId}/brand/${this.props.params.brandToken}`);
  }

  getCartSelection() {
    let cartSelection = null;
    let cart = Api.cache.getCart();
    if (cart && cart.cart && cart.cart.items && cart.cart.items.length > 0) {
      let productOptionsInCart = cart.cart.items.filter(cartItem => {
        return cartItem.product_token === this.state.productToken;
      });

      if (productOptionsInCart.length > 0) {
        let product = cart.products[productOptionsInCart[0].product_token];
        let batchCount = product.options[0].unit_multiplier;
        cartSelection = productOptionsInCart.map(cartItem => {
          return {
            option: cartItem.product_option_token,
            batches: cartItem.quantity / batchCount
          };
        });
      }
    }

    return cartSelection;
  }

  addToCart(productToken, productOptions) {
    let cartItems = null;

    return this.getRecommendedProduct(productToken)
      .then(product => {
        if (!product) {
          console.error('Cannot find product with token %s', productToken);
          console.error(this.state.recommendations);
        }

        cartItems = productOptions.map(selection => {
          let selectedOption = product.options.find((option) => {
            return (selection.option === option.token);
          });
          let bagEntry = {};
          bagEntry.brand_token = product.brand_token;
          bagEntry.product_token = product.token;
          bagEntry.product_option_token = selectedOption.token;
          bagEntry.quantity = selection.batches * selectedOption.unit_multiplier;
          bagEntry.price_cents = selectedOption.wholesale_price_cents;

          return bagEntry;
        });
      })
      .then(() => {
        let oldSelection = this.getCartSelection();

        if (oldSelection && oldSelection.length > 0) {
          return Api.removeFromCart(oldSelection.map(selection => selection.option));
        }
      })
      .then(() => Api.addToCart(cartItems))
      .then((result) => {
        this.redirectToBrandPage();
        return result;
      });
  }

  searchChanged() {
    let searchTerm = Api.cache.getProductSearchTerm();
    if (searchTerm !== '') {
      this.context.router.push(`/retailer/${this.props.params.retailerId}`);
    }
  }


  onCategory(category, subcategory, filter) {
    let params = {
      category,
      subcategory,
      filter: (filter && filter.value) || null
    };

    let queryString = Object.keys(params)
      .filter((key) => {
        return params[key];
      })
      .map((key) => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
      })
      .join('&');

    this.context.router.push(`/retailer/${this.props.params.retailerId}?${queryString}`);
  }

  onBreadCrumb(_, position) {
    // only care about home
    if (position !== 0) {
      return;
    }

    this.context.router.push(`/retailer/${this.props.params.retailerId}`);
  }

  render() {
    if (!this.state.recommendations || !this.state.categories) {
      return (
        <div className="retailer-loading-wrapper">
          <Processing />
        </div>
      );
    }

    let brands = {};
    if (this.state.brandInfo) brands[this.state.brandInfo.token] = this.state.brandInfo;

    let productDict = {};
    let displayOrder = [];
    this.state.recommendations.forEach(product => {
      displayOrder.push(product.token);
      productDict[product.token] = product;
    });

    return (
      <div className="brand-component">
        <CategoryBar categories={this.state.categories}
                     filters={CATEGORY_FILTERS}
                     onSelect={this.onCategory}/>
        <BrandHeader brand={this.state.brandInfo}
                     closestBrandRetailer={this.state.closestBrandRetailer}
                     recommendations={this.state.recommendations}/>
        <CollectionStrip brandToken={this.state.brandInfo.token} retailerToken={this.props.params.retailerId}/>
        <BreadCrumb onSelect={this.onBreadCrumb} primary={this.state.brandInfo.name}/>
        <RecommendationGrid
          retailerToken={this.props.params.retailerId}
          products={productDict}
          collections={{}}
          display_order={displayOrder}
          brands={brands}
          selectProduct={this.selectProduct}/>
        {this.productModal()}
      </div>
    );
  }
}

Brand.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/views/Brand/index.js
 **/